import { Form, Input } from "decorator-form";
import { css } from "styled-components";

import InputType from "common/form/InputType";
import SubFormWidget from "common/form/widgets/SubFormWidget";

/**
 * @author chills
 * @description reusable config for Font Awesome Icon styles. See {@link SubFormWidget}
 */

@Form({title: "Font Awesome Icon Styles"})
export class FontAwesomeIconStylesConfig {

	@Input({type: InputType.COLOR, title: "Text Color"})
	public color?: string;

	@Input({type: InputType.PADDING, title: "Padding"})
	public padding?: string;

	@Input({type: InputType.MARGIN, title: "Margin"})
	public margin?: string;

	@Input({type: InputType.UNIT, title: "Max Width"})
	public maxWidth?: string;

	@Input({type: InputType.UNIT, title: "Min Width"})
	public minWidth?: string;

	@Input({type: InputType.UNIT, title: "Max Height"})
	public maxHeight?: string;

	@Input({type: InputType.UNIT, title: "Min Height"})
	public minHeight?: string;

	@Input({type: InputType.UNIT, title: "Icon Size"})
	public iconSize: number = 16;
}

// use this as your input type
export const fontAwesomeIconStylesInput = SubFormWidget.registerForm(FontAwesomeIconStylesConfig);

// convert to TemplateStringArray for styled-components
export function toBlockCss(data: FontAwesomeIconStylesConfig) {
	return data ? css`
		color: ${data.color};
		padding: ${data.padding};
		margin: ${data.margin};
		max-width: ${data.maxWidth};
		min-width: ${data.minWidth};
		max-height: ${data.maxHeight};
		min-height: ${data.minHeight};
		font-size: ${data.iconSize};
	` : undefined;
}



// WEBPACK FOOTER //
// ./src/common/views/common/FontAwesomeIconStylesConfig.ts